import { getBooleanFeatureFlag } from '@atlassian/jira-portfolio-3-common/src/feature-flags/utils.tsx';

const isUsingReselectWrapper = () =>
	getBooleanFeatureFlag('com.atlassian.rm.jpo.jpo3cloud.use-reselect-wrapper-library');

export default isUsingReselectWrapper;
